import { CheckBoxIcon } from "../../../../assets";


export const PREFERENCES = [
    'All',
    '1st Preference',
    '2nd Preference',
    '3rd Preference',
];

export const BAR_CHART_LEGENDS = [
    { label: 'E-mail', icon: <CheckBoxIcon /> },
    { label: 'Banners', icon: <CheckBoxIcon /> },
    { label: 'Programmatic', icon: <CheckBoxIcon /> },
    { label: 'Custom media', icon: <CheckBoxIcon /> },
    { label: 'Endemic social', icon: <CheckBoxIcon /> },
    { label: 'SMS', icon: <CheckBoxIcon /> },
    { label: 'Direct mail', icon: <CheckBoxIcon /> },
    { label: 'EHR', icon: <CheckBoxIcon /> },
];

export const CHART_OPTIONS = {
    chart: {
        type: 'bar',
        toolbar: {
            show: false,
        },
        stacked: true,
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    colors: ['#F3DBF1', '#DB97D2', '#AD509E', '#733567', '#3D1535'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
            dataLabels: {
                position: 'top',
            },
        },
    },
    dataLabels: {
        enabled: true,
        textAnchor: "middle",
        style: {
            colors: ['#FFFFFF'],
            fontSize: '12px',
            fontWeight: '500',                    
        },
        formatter: function (val, opt) {
            let formattedVal = Number(val).toString() + '%';
            return formattedVal;
        },
    },
    legend: {
        position: 'top',
        horizontalAlign: 'center',
        markers:{
            radius:12,
        },
    },
    grid: {
        show: true,
    },
    xaxis: {
        title: {
            text: 'Channels',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title',
            },
        },
        categories: [
            'E-mail',
            'Banners',
            'Programmatic',
            'Custom media',
            'Endemic social',
            'SMS',
            'Direct mail',
            'EHR',
        ],
        labels:{
            formatter: function (val) {
                return val.length > 30 ? val.substring(0, 30) + '...' : val;
            },
            style:{
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: 'Inter',
                cssClass: 'apexcharts-xaxis-label-custom-color',
            },
        },  
    },
    yaxis: {
        min: 0,
        max: 100,
        title: {
            text: "% HCPs",
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title',
            },
        },
        labels: {
            formatter: function (val) {
              return val + '%';
            },
            style: {
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label',
            },
        },
        tickAmount: 5,
        max: 100,
    },
    tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}) {
            let dataPointName = w.globals.labels[dataPointIndex];
            let seriesName = w.globals.seriesNames[seriesIndex];
            let value = series[seriesIndex][dataPointIndex];

            return `<div class="custom-tool-tip-container arrow_box tool_tip_fullName"> 
                    <p class="tool-tip-label-name margin-0 fw_bold">${dataPointName}</p>
                    <p class="tool-tip-series-name margin-0">${seriesName}: ${value}%</p>                
                </div>`
        }        
    },
};

export const CHART_SERIES = [
    {
        name: 'Low',
        data: [15.2, 12.1, 31.4, 15.2, 11.6, 9.6, 15.2, 15.2],
    },
    {
        name: 'Medium',
        data: [48.7, 37.5, 12.1, 49.2, 26.9, 46.7, 13.1, 23.3],
    },
    {
        name: 'High',
        data: [19.2, 20.8, 38.5, 26.3, 36.5, 27, 52.7, 38.2],
    },
    {
        name: 'Very High',
        data: [16.7,     29.4, 17.7, 9.1, 24.8, 16.7, 18.7, 23.3],
    },
    // {
    //     name: 'Email',
    //     // data: [15.2, 12.1, 31.4, 15.2, 11.6, 9.6, 15.2, 15.2],
    //     data:[15.2, 48.7, 19.2, 16.7]
    // },
    // {
    //     name: 'Banners',
    //     // data: [48.7, 37.5, 12.1, 49.2, 26.9, 46.7, 13.1, 23.3],
    //     data:[12.1, 37.5, 20.8, 29.4]
    // },
    // {
    //     name: 'Programmatic',
    //     // data: [19.2, 20.8, 38.5, 26.3, 36.5, 27, 52.7, 38.2],
    //     data:[31.4, 12.1, 38.5, 17.7]
    // },
    // {
    //     name: 'Custom media',
    //     // data: [16.7, 29.4, 17.7, 9.1, 24.8, 16.7, 18.7, 23.3],
    //     data:[15.2, 49.2, 26.3, 9.1]
    // },
    // {
    //     name: 'Endemic social',
    //     // data: [15.2, 12.1, 31.4, 15.2, 11.6, 9.6, 15.2, 15.2],
    //     data:[11.6, 26.9, 36.5, 24.8]
    // },
    // {
    //     name: 'SMS',
    //     // data: [48.7, 37.5, 12.1, 49.2, 26.9, 46.7, 13.1, 23.3],
    //     data:[9.7, 46.7, 27, 16.7]
    // },
    // {
    //     name: 'Direct mail',
    //     // data: [19.2, 20.8, 38.5, 26.3, 36.5, 27, 52.7, 38.2],
    //     data:[15.2, 13.1, 52.7, 18.7]
    // },
    // {
    //     name: 'EHR',
    //     // data: [16.7, 29.4, 17.7, 9.1, 24.8, 16.7, 18.7, 23.3],
    //     data:[15.2, 23.3, 38.2, 23.3]
    // },
];
